import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axiosInstance';

const Navbar = (props) => {
  const [moderatorsName, setModeratorsName] = useState('');
  const [moderatorsUID, setModeratorsUID] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchShortProfile = async () => {
      try {
        const response = await api.get('/clients/profile');
        if (response.data.error) {
          setError(response.data.message);
          console.log(error);
        } else {
          setModeratorsName(response.data.profile.name);
          setModeratorsUID(response.data.profile.username);
        }
      } catch (err) {
        setError('Login failed. Please try again.');
      }
    }
    fetchShortProfile();
  }, [error]);

  return (
    <>
      <nav className="fixed z-40 w-full bg-[#f4f6f7] border-b border-gray-200 dark:bg-gray-900 dark:border-gray-700">
        <div className="px-3 py-3 lg:px-5 lg:pl-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-start">
              <button id="toggleSidebarMobile" aria-expanded="true" data-drawer-target="sidebar" data-drawer-toggle="sidebar" aria-controls="sidebar" className="p-2 text-gray-600 rounded cursor-pointer lg:hidden hover:text-gray-900 hover:bg-gray-100 focus:bg-gray-100 dark:focus:bg-gray-700 focus:ring-2 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                <svg id="toggleSidebarMobileHamburger" className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"></path></svg>
                <svg id="toggleSidebarMobileClose" className="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
              </button>
              <Link to={'/dashboard'} className="flex ml-2 md:mr-16">
                <div className="self-center w-48 text-xl font-semibold sm:text-2xl whitespace-nowrap dark:text-white">
                  <a href="/" aria-label="Webhizzy logo" className="flex items-center">
                    <img alt='' src="/images/logo.svg" alt="Logo" className='' width="142px" />
                    {/* <span className="ps-2 text-2xl font-bold text-gray-900 dark:text-white"> Webhizzy</span> */}
                  </a>
                </div>
              </Link>

              <nav
                className="flex mr-auto hidden lg:block mt-1 lg:w-96"
                aria-label="Breadcrumb"
              >
                <ol className="inline-flex items-center space-x-1 text-sm font-medium md:space-x-2">
                  <li className="inline-flex items-center">
                    <Link
                      to="/dashboard"
                      className="inline-flex items-center text-[#141718] hover:text-[#3959ff] dark:text-gray-300 dark:hover:text-white"
                    >
                      <svg
                        className="flex-shrink-0 w-5 h-5 transition duration-75"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M4 13h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm-1 7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4zm10 0a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v7zm1-10h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1z"></path>
                      </svg>
                    </Link>
                  </li>
                  {props.breadcrumb.map((title, index) =>
                    props.breadcrumb.length !== index + 1 || index === 0 ? (
                      <li key={index} className="inline-flex items-center">
                        <Link
                          to={props.breadcrumbLink[index]}
                          className="inline-flex items-center text-[#141718] hover:text-[#3959ff] dark:text-gray-300 dark:hover:text-white"
                        >
                          <svg
                            className="w-6 h-6 text-[#141718]"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                          {title}
                        </Link>
                      </li>
                    ) : (
                      <li key={index}>
                        <div className="inline-flex items-center pt-1">
                          <svg
                            className="w-6 h-6 text-[#141718]"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                          <Link
                            to={props.breadcrumbLink[index]}
                            className="ml-1 text-[#141718] md:ml-2 dark:text-gray-400"
                            aria-current="page"
                          >
                            {title}
                          </Link>
                        </div>
                      </li>
                    )
                  )}
                </ol>
              </nav>
              {/* <form action="#" method="GET" className="hidden lg:block lg:pl-3.5">
                <label for="topbar-search" className="sr-only">Search</label>
                <div className="relative mt-1 lg:w-96">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path></svg>
                  </div>
                  <input type="text" name="email" id="topbar-search" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Search" />
                </div>
              </form> */}
            </div>
            <div className="flex items-center">
              <div className="hidden mr-3 -mb-1 sm:block">
                <span></span>
              </div>
              {/* -------------- Search ------------ */}

              {/* <button id="toggleSidebarMobileSearch" type="button" className="p-2 text-gray-500 rounded-lg lg:hidden hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                <span className="sr-only">Search</span>

                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path></svg>
              </button> */}

              {/* -------------- Notifications ------------ */}

              {/* <button type="button" data-dropdown-toggle="notification-dropdown" className="p-2 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700">
                <span className="sr-only">View notifications</span>

                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"></path></svg>
              </button>

              <div className="z-20 z-50 hidden max-w-sm my-4 overflow-hidden text-base list-none bg-white divide-y divide-gray-100 rounded shadow-lg dark:divide-gray-600 dark:bg-gray-700 notification" id="notification-dropdown" data-popper-placement="bottom">
                <div className="block px-4 py-2 text-base font-medium text-center text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  Notifications
                </div>
                <div>
                  <a href="#" className="flex px-4 py-3 border-b hover:bg-gray-100 dark:hover:bg-gray-600 dark:border-gray-600">
                    <div className="flex-shrink-0">
                      <img className="rounded-full w-11 h-11" src="https://flowbite-admin-dashboard.vercel.app/images/users/bonnie-green.png" alt="Jese image" />
                      <div className="absolute flex items-center justify-center w-5 h-5 ml-6 -mt-5 border border-white rounded-full bg-primary-700 dark:border-gray-700">
                        <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"></path><path d="M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"></path></svg>
                      </div>
                    </div>
                    <div className="w-full pl-3">
                      <div className="text-gray-500 font-normal text-sm mb-1.5 dark:text-gray-400">New message from <span className="font-semibold text-gray-900 dark:text-white">Bonnie Green</span>: "Hey, what's up? All set for the presentation?"</div>
                      <div className="text-xs font-medium text-primary-700 dark:text-primary-400">a few moments ago</div>
                    </div>
                  </a>
                </div>
                <a href="#" className="block py-2 text-base font-normal text-center text-gray-900 bg-gray-50 hover:bg-gray-100 dark:bg-gray-700 dark:text-white dark:hover:underline">
                  <div className="inline-flex items-center ">
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z"></path><path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"></path></svg>
                    View all
                  </div>
                </a>
              </div> */}

              {/* -------------- Dark Theme ------------ */}

              {/*<button id="theme-toggle" data-tooltip-target="tooltip-toggle" type="button" className="text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm p-2.5">
                <svg id="theme-toggle-dark-icon" className="w-5 h-5 hidden" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path></svg>
                <svg id="theme-toggle-light-icon" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" fillRule="evenodd" clipRule="evenodd"></path></svg>
              </button> 

              <div id="tooltip-toggle" role="tooltip" className="absolute z-10 inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm tooltip opacity-0 invisible themeToggle2" data-popper-placement="bottom">
                Toggle dark mode
                <div className="tooltip-arrow themeToggle" data-popper-arrow=""></div>
              </div>*/}

              <button
                type="button"
                data-dropdown-toggle="apps-dropdown"
                className="p-2 text-[#141718] rounded-lg sm:flex hover:text-[#3959ff] hover:bg-[rgba(188,0,135,0.07)] dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700 focus:bg-white focus:text-[#3959ff]"
              >
                <span className="sr-only">View apps</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path></svg>
              </button>

              <div className="z-20 z-50 max-w-sm overflow-hidden text-base list-none bg-white divide-y divide-gray-100 rounded shadow-lg dark:bg-gray-700 dark:divide-gray-600 hidden" id="apps-dropdown" aria-hidden="true" data-popper-placement="bottom">
                <div className="block px-4 py-2 text-base font-medium text-center text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  Apps
                </div>
                <div className="grid grid-cols-3 gap-4 p-4">
                  <Link to={'/dashboard/profile'} className="block p-4 text-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600">
                    <img alt='account' src='/images/icons/account.svg' className="mx-auto mb-1 text-gray-500 w-7 h-7 dark:text-gray-400" />
                    <div className="text-sm font-medium text-gray-900 dark:text-white">Account</div>
                  </Link>
                  <Link to={'https://files.webhizzy.in/'} target='_blank' className="block p-4 text-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600">
                    <img alt='Files' src='/images/icons/file-manager.svg' className="mx-auto mb-1 text-gray-500 w-7 h-7 dark:text-gray-400" />
                    <div className="text-sm font-medium text-gray-900 dark:text-white">File Manager</div>
                  </Link>
                  <Link to={'https://db.webhizzy.in/'} target='_blank' className="block p-4 text-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600">
                    <img alt='' src='/images/icons/phpmyadmin.svg' className="mx-auto mb-1 text-gray-500 w-7 h-7 dark:text-gray-400" />
                    <div className="text-sm font-medium text-gray-900 dark:text-white">php myAdmin</div>
                  </Link>
                  <Link to={'https://mail.webhizzy.in/'} target='_blank' className="block p-4 text-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600">
                    <img alt='' src='/images/icons/mail.svg' className="mx-auto mb-1 text-gray-500 w-7 h-7 dark:text-gray-400" />
                    <div className="text-sm font-medium text-gray-900 dark:text-white">Business Email</div>
                  </Link>
                  <Link to={'https://mailadmin.webhizzy.in/'} target='_blank' className="block p-4 text-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600">
                    <img alt='' src='/images/icons/mail-admin.svg' className="mx-auto mb-1 text-gray-500 w-7 h-7 dark:text-gray-400" />
                    <div className="text-sm font-medium text-gray-900 dark:text-white">Mail Admin</div>
                  </Link>
                  <Link to={'/Marketing'} className="block p-4 text-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600">
                    <img alt='' src='/images/icons/marketing.svg' className="mx-auto mb-1 text-gray-500 w-7 h-7 dark:text-gray-400" />
                    <div className="text-sm font-medium text-gray-900 dark:text-white">Marketing CRM</div>
                  </Link>
                  <Link to={'https://webhizzy.in/pricing.html?category=maketing-solutions'} target='_blank' className="block p-4 text-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600">
                    <img alt='' src='/images/icons/timer.svg' className="mx-auto mb-1 text-gray-500 w-7 h-7 dark:text-gray-400" />
                    <div className="text-sm font-medium text-gray-900 dark:text-white">Countdown Timer</div>
                  </Link>
                  <Link to={'https://webhizzy.in/contact.html'} target='_blank' className="block p-4 text-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600">
                    <img alt='' src='/images/icons/support.svg' className="mx-auto mb-1 text-gray-500 w-7 h-7 dark:text-gray-400" />
                    <div className="text-sm font-medium text-gray-900 dark:text-white">Support</div>
                  </Link>
                  <Link to={'https://payments.webhizzy.in/'} target='_blank' className="block p-4 text-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-600">
                    {/* <svg className="mx-auto mb-1 text-gray-500 w-7 h-7 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm2.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.207.293a1 1 0 00-1.414 0l-6 6a1 1 0 101.414 1.414l6-6a1 1 0 000-1.414zM12.5 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" clip-rule="evenodd"></path></svg> */}
                    <img alt='' src='/images/icons/billing.svg' className="mx-auto mb-1 text-gray-500 w-7 h-7 dark:text-gray-400" />
                    <div className="text-sm font-medium text-gray-900 dark:text-white">Billing</div>
                    </Link>
                </div>
              </div>

              <div className="flex items-center ml-3">
                <div>
                  <button type="button" className="flex text-sm bg-gray-900 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600" id="user-menu-button-2" aria-expanded="false" data-dropdown-toggle="dropdown-2">
                    <span className="sr-only">Open user menu</span>
                    <img className="w-8 h-8 rounded-full" src="/images/profile.jpg" alt="Profile" />
                  </button>
                </div>

                <div className="z-50 hidden min-w-[152px] my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600 profileMenu" id="dropdown-2" data-popper-placement="bottom">
                  <div className="px-4 py-3" role="none">
                    <p className="text-sm text-gray-900 dark:text-white" role="none">
                      {moderatorsName}
                    </p>
                    <p className="text-sm font-medium text-gray-900 truncate dark:text-gray-300" role="none">
                      {moderatorsUID}
                    </p>
                  </div>
                  <ul className="py-1" role="none">
                    <li>
                      <Link to={'/dashboard'} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Dashboard</Link>
                    </li>
                    <li>
                      <Link to={'/dashboard/profile'} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Profile</Link>
                    </li>
                    <li>
                      <Link to={'/logout'} className="cursor-pointer block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white" role="menuitem">Sign out</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
